import { WidgetKey } from 'shared/constants/widgets'
import { AiArtifactConfig, PersistedWidgetSpec } from 'shared/types/widgets'

export const isAiArtifactTile = (
  item: PersistedWidgetSpec
): item is PersistedWidgetSpec & { config: AiArtifactConfig } =>
  item.widgetKey === WidgetKey.AI_ARTIFACT_TILE &&
  Boolean((item.config as AiArtifactConfig | undefined)?.publicId)
